var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "material-icons-24p"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3017_36245",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3017_36245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "attach_file",
    d: "M11.4997 21.8848C10.0369 21.8848 8.79297 21.3723 7.76797 20.3473C6.74297 19.3223 6.23047 18.0784 6.23047 16.6156V5.80786C6.23047 4.75546 6.60519 3.85454 7.35464 3.10511C8.10408 2.35567 9.00499 1.98096 10.0574 1.98096C11.1098 1.98096 12.0107 2.35567 12.7601 3.10511C13.5096 3.85454 13.8843 4.75546 13.8843 5.80786V15.5579C13.8843 16.2256 13.6538 16.7899 13.1927 17.251C12.7316 17.712 12.1672 17.9425 11.4994 17.9425C10.8317 17.9425 10.2673 17.712 9.80642 17.251C9.34554 16.7899 9.11509 16.2256 9.11509 15.5579V5.80786H10.3074V15.5579C10.3074 15.8957 10.4216 16.1789 10.6502 16.4074C10.8787 16.6359 11.1619 16.7502 11.4997 16.7502C11.8375 16.7502 12.1207 16.6359 12.3492 16.4074C12.5778 16.1789 12.692 15.8957 12.692 15.5579V5.80786C12.692 5.07016 12.4373 4.44663 11.9277 3.93728C11.4182 3.42792 10.7945 3.17323 10.0566 3.17323C9.31865 3.17323 8.6952 3.42792 8.18622 3.93728C7.67725 4.44663 7.42277 5.07016 7.42277 5.80786V16.6156C7.42277 17.7412 7.82084 18.7021 8.61699 19.4983C9.41314 20.2944 10.374 20.6925 11.4997 20.6925C12.6253 20.6925 13.5862 20.2944 14.3824 19.4983C15.1785 18.7021 15.5766 17.7412 15.5766 16.6156V5.80786H16.7689V16.6156C16.7689 18.0784 16.2564 19.3223 15.2314 20.3473C14.2064 21.3723 12.9625 21.8848 11.4997 21.8848Z",
    fill: "#AFAFAF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.6a2db3b34616d0d2e85d48b00b27c8e6.svg";
export { ForwardRef as ReactComponent };